export default __webpack_public_path__ + "static/media/Westermarck Mantle.57e03541.jpg";